import React from "react";
import Settings from "./settings";

import UserStore from "./stores/user.store";
import SettingsStore from "./stores/settings.store";
import DictionariesStore from "./stores/dictionaries.store";
import SportObjectsStore from "./stores/sportObjects.store";
import SportZonesStore from "./stores/sportZones.store";
import SportSubZonesStore from "./stores/sportSubZones.store";
import EquipmentsStore from "./stores/equipments.store";
import ServiceJobsStore from "./stores/serviceJobs.store";
import ServicePeriodStore from "./stores/servicePeriod.store";
import EquipmentRelocationRequestStore from "./stores/equipmentRelocationRequest.store";
import { makeAutoObservable } from "mobx";
import { ApolloClient, createHttpLink, DefaultOptions, InMemoryCache } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { from } from "@apollo/client";
import GalleryStore from "./stores/gallery.store";
import { injectStores } from "@mobx-devtools/tools";
import SpecificationsStore from "./stores/specifications.store";
import { cache } from "cache";


console.log('[Apollo] Server URL:', Settings.server);
console.log('[Apollo] GraphQL endpoint:', `${Settings.server}/graphql`);

const httpLink = createHttpLink({
	uri: `${Settings.server}/graphql`,
	credentials: 'same-origin', // Используем same-origin для совместимости с iframe
});

const authLink = setContext((_, {headers}) => {
	// get the authentication token from local storage if it exists
	const token = localStorage.getItem('user_token');

	// return the headers to the context so httpLink can read them
	return {
		headers: {
			...headers,
			Authorization: token ? `Bearer ${token}` : "",
		}
	}
});

const defaultOptions: DefaultOptions = {
	watchQuery: {
		fetchPolicy: 'cache-first',
	},
	query: {
		fetchPolicy: 'cache-first',
	},
}

// Declare rootStore variable that will be initialized later (using any to avoid forward reference issue)
let rootStore: any;

// Create error link that will access rootStore when called
const errorLink = onError(({ graphQLErrors, networkError }) => {
	if (graphQLErrors) {
		graphQLErrors.forEach(({ message, extensions }) => {
			// Handle authentication errors
			if (extensions?.code === 'UNAUTHENTICATED' || message === 'Could not authenticate with token') {
				console.error('Authentication error:', message);
				// Clear user session - this will trigger redirect in App.tsx
				// Check if rootStore is initialized before accessing it
				if (rootStore) {
					const loggedOut = localStorage.getItem('user_logged_out');
					if (!loggedOut || !JSON.parse(loggedOut)) {
						// Only clear if user hasn't already logged out manually
						rootStore.userStore.setLoginError(true);
						rootStore.userStore.setLoginErrorMessage('Не удалось пройти аутентификацию с помощью токена');
                        void rootStore.userStore.clearUser({ revokeRemote: false, manual: false });
					}
				} else {
					localStorage.clear();
					localStorage.setItem('user_logged_out', JSON.stringify(true));
				}
				// Исключаем страницу SSO из редиректа
				if (!window.location.pathname.endsWith('/login') && !window.location.pathname.includes('/sso')) {
					window.location.href = '/login';
				}
			}
		});
	}

	if (networkError) {
		console.error('Network error:', networkError);
	}
});

// Create client BEFORE rootStore so stores can access it during initialization
export const client = new ApolloClient({
	cache,
	link: from([errorLink, authLink, httpLink]),
	defaultOptions: defaultOptions,
	connectToDevTools: true,
});

export default class RootStore {
	public userStore: any;
	public contractsStore: any;
	public sportObjectsStore: any;
	public settingsStore: any;
	public dictionariesStore: any;
	public sportZonesStore: any;
	public sportSubZonesStore: any;
	public equipmentsStore: any;
	public serviceJobsStore: any;
	public servicePeriodStore: any;
	public equipmentRelocationRequestStore: any;
	public galleryStore: any;
	public specificationsStore: any;
	public snake: any = {
		msg: "",
		type: 'default'
	};


	constructor() {
		makeAutoObservable(this)
		this.userStore = new UserStore(this)

		this.settingsStore = new SettingsStore(this)
		this.dictionariesStore = new DictionariesStore(this)
		this.sportObjectsStore = new SportObjectsStore(this)
		this.sportZonesStore = new SportZonesStore(this)
		this.sportSubZonesStore = new SportSubZonesStore(this)
		this.equipmentsStore = new EquipmentsStore(this)
		this.serviceJobsStore = new ServiceJobsStore(this)
		this.servicePeriodStore = new ServicePeriodStore(this)
		this.equipmentRelocationRequestStore = new EquipmentRelocationRequestStore(this)
		this.galleryStore = new GalleryStore(this)
		this.specificationsStore = new SpecificationsStore(this)
	}

	setSnakeMessage = (msg: string, type: string = "default") => {
		this.snake = {msg, type}
	}

}

// Initialize rootStore after client is created
rootStore = new RootStore();
export { rootStore };

injectStores({
	rootStore
});

const StoresContext = React.createContext(rootStore);
export const useStores = () => React.useContext(StoresContext);

function persistCache(arg0: { cache: InMemoryCache; storage: Storage; }) {
    throw new Error('Function not implemented.');
}
